import React from "react";
import type { ModalRadioButtonProps } from "../../types";
import { ModalRadioButtonStyle } from "../EditTravellersModal";

const ModalRadioButton: React.FC<ModalRadioButtonProps> = ({
  children,
  activeBtn,
  inputId,
  name = "radio-group",
}) => {
  return (
    <ModalRadioButtonStyle>
      <input
        type="radio"
        checked={activeBtn}
        id={inputId}
        name={name}
        readOnly
      />
      <label htmlFor={inputId}>{children}</label>
    </ModalRadioButtonStyle>
  );
};

export default ModalRadioButton;
